import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllCourses, fetchCourseById } from '../../services/firestore/courseService';

/**
 * Fetch all courses from Firestore
 */
export const fetchCourses = createAsyncThunk(
  'courses/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const courses = await fetchAllCourses();
      return courses;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch courses');
    }
  }
);

/**
 * Fetch a single course by ID from Firestore
 */
export const fetchCourse = createAsyncThunk(
  'courses/fetchById',
  async (courseId: string, { rejectWithValue }) => {
    try {
      const course = await fetchCourseById(courseId);
      if (!course) {
        return rejectWithValue('Course not found');
      }
      return course;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch course');
    }
  }
);

